import React, {Fragment} from 'react'
import {  
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from '@material-ui/core'

export default function TotalChart(props) {
  const { darkMode, data } = props  

  return(    
    <Fragment>
      <Table style={{height: "80%"}}>
        <TableHead style={{height: "25%"}}>
          <TableRow>
            <TableCell align="center" colSpan={2}>
              <Typography variant="caption" style={{fontWeight: 'bold', color: `${darkMode ? "#fff" : "#6e6e6e"}`}}>TOTAL CUSTOMERS BY YEAR</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell><Typography variant="caption" style={{fontSize: 11, fontWeight: 'bold', color: `${darkMode ? "#fff" : "#6e6e6e"}`}}>Year</Typography></TableCell>
            <TableCell align="right" style={{borderLeft: '1px solid #dcdcdc'}}><Typography variant="caption" style={{fontSize: 11, fontWeight: 'bold', color: `${darkMode ? "#fff" : "#6e6e6e"}`}}>Customer Count</Typography></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(row => (
            <TableRow key={row.name} style={{height: 65}}>
              <TableCell><Typography variant="caption" style={{color: `${darkMode ? "#fff" : "#6e6e6e"}`}}>{row.name}</Typography></TableCell>
              <TableCell align="right" style={{borderLeft: '1px solid #dcdcdc'}}>
                <Typography variant="caption" style={{color: `${darkMode ? "#fff" : "#6e6e6e"}`}}>{Number.isNaN(row.data.reduce((a,b) => a + b, 0)) ? 0 : row.data.reduce((a,b) => a + b, 0).toLocaleString('en')}</Typography>
                {/* <Typography variant="caption">{row.data.reduce((a,b) => a + b, 0).toLocaleString('en')}</Typography> */}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>    
      <br/>
      <div>
        <Typography variant="caption" style={{fontWeight: 'bold', color: `${darkMode ? "#fff" : "#6e6e6e"}`}}>
          Total Customer Count:<br/>
          <span style={{fontWeight: 'bold', fontSize: '25px', color: '#25aae1'}}>
            {data.map(({data}) => data.reduce((a,b) => a + b, 0)).reduce((a,b) => a + b, 0).toLocaleString("en")}            
          </span>
        </Typography>
      </div>
      </Fragment>
    // </div>
  )
}
